$shm_hitalama_components_preview_description $mol_view
	definition $shm_hitalama_map_widget_entity_custom
	sub /
		<= Header $mol_view
			sub /
				<= Label $mol_view
					sub / \Описание
				^ actions /$mol_view
					<= Edit $mol_button_minor
						hint \Редактировать описание
						click? <=> edit? null
						sub / <= Edit_icon $mol_icon_pencil
		^ content /$mol_view
			<= Text $shm_hitalama_text
				text <= text \
	Cancel $mol_button_minor
		title \Отмена
		click? <=> cancel? null
	Textarea $mol_textarea
		hint \Описание
		value? <=> draft? \
	Save $mol_button_major
		title \Сохранить
		click? <=> save? null
